import find from 'lodash/find'
import includes from 'lodash/includes'
import { useUserStore } from '@/store/userStore'

export default function ({ store, redirect, route }) {
  const userStore = useUserStore()

  // Valida si usuario esta logueado y es superadmin
  if (userStore.loggedIn && !isSuperAdmin(store.state.users.user)) {
    // Si no es superadmin pero es admin valida si tiene permitido ver el submodulo
    if (
      userStore.loggedIn &&
      isAdmin(store.state.users.user) &&
      !isAllowedSubmodule(store.state.users.user, route) &&
      !isOfficer(store.state.users.user) &&
      !isVisualizer(store.state.users.user)
    ) {
      return redirect('/forbidden')
    } else if (
      userStore.loggedIn &&
      !isAdmin(store.state.users.user) &&
      !isOfficer(store.state.users.user) &&
      !isVisualizer(store.state.users.user)
    ) {
      return redirect('/forbidden')
    }
  }
}

function isAllowedSubmodule(user, route) {
  let moduleId = route.params.moduleId
  let submoduleId = route.params.submoduleId
  if (route.query && route.query.moduleId) moduleId = route.query.moduleId
  if (route.query && route.query.submoduleId)
    submoduleId = route.query.submoduleId
  const result = find(user.availableModules, (availableModule) => {
    if (availableModule.submodule && availableModule.submodule !== '') {
      return (
        availableModule.module === moduleId &&
        availableModule.submodule === submoduleId
      )
    } else {
      return availableModule.module === moduleId
    }
  })
  return !!result
}

function isAdmin(user) {
  return (
    user &&
    user.role &&
    includes(['superadmin', 'admin', 'operator', 'editor'], user.role)
  )
}

function isOfficer(user) {
  return user && user.auxRole && user.auxRole === 'officer'
}

function isSuperAdmin(user) {
  return user && user.role && user.role === 'superadmin'
}

function isVisualizer(user) {
  return user && user.auxRole && user.auxRole === 'visualizer'
}
